import { computed, ref, onMounted } from 'vue';

export const useIsInIframe = () => {
  const isMounted = ref(false);

  onMounted(() => {
    isMounted.value = true;
  });

  return computed(() => isMounted.value && globalThis.self !== globalThis.top);
};
